<div class="d-flex align-items-center justify-content-between w-100">
    <div class="mt-1">
        <a id="btn-toggle" href="javascript:void(0)" class="sidebar-toggler break-point-lg">
            <i class="ri-menu-line ri-xl"></i>
        </a>
    </div>

    <table aria-describedby="headerTable">
        <tr>
            <td>
                <div [matMenuTriggerFor]="menu" (menuOpened)="isMenuOpen = true" (menuClosed)="isMenuOpen = false"
                    class="user-profile-dropdown d-flex align-items-center">
                    <img class="avatar avatar-sm rounded-circle cursor-pointer me-2"
                    [src]="userImage || 'assets/images/default-user-profile.svg'"
                    (error)="onImageError($event)"
                    alt="User Image" />

                    <span id="customerNameContainer" class="d-flex align-items-center">
                        <span class="username truncatedName align-self-center me-1 cursor-pointer text-white">
                            {{ userName }}
                        </span>
                        <i class="ms-1" [class.fas]="true" [class.fa-chevron-up]="isMenuOpen"
                            [class.fa-chevron-down]="!isMenuOpen"></i>
                    </span>
                </div>
                <mat-menu #menu="matMenu" class="user-dropdown">
                    <a (click)="openDialog()" mat-menu-item>
                        <span><img src="../../../assets/images/profile-circle.svg" class="me-2 image-w" alt="">My
                            Account</span>
                    </a>
                    <a mat-menu-item (click)="openDialogChangePassword()">
                        <span><img src="../../../assets/images/lock.svg" class="me-2 image-w" alt="">Change
                            Password</span>
                    </a>

                    <a (click)="logOut()" mat-menu-item> <span><img src="assets/images/logout-icon.svg"
                                class="me-2 image-w" alt="">Logout</span>
                    </a>
                </mat-menu>
            </td>
        </tr>
    </table>
</div>